module.exports = __webpack_public_path__ + "static/fipcahoywhale4-39b2561815589a9f7e704289ee50841e.jpeg";